
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/stores",
      function () {
        return require("private-next-pages/en/stores.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en/stores"])
      });
    }
  